module.exports = __webpack_public_path__ + "static/media/sparen_bank.49c070c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/sparen_bank.svg
// module id = 180
// module chunks = 0